import styled from 'styled-components';

export const FilterBarContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${(props) => props.theme.spacing.md};
  padding: ${(props) => props.theme.spacing.sm} 0;
  flex-wrap: wrap;
`;

export const FormWrapper = styled.div`
  flex: 1;
  min-width: 0;

  .rjsf {
    display: flex;
    align-items: flex-end;
    gap: ${(props) => props.theme.spacing.md};
    flex-wrap: wrap;
  }

  .rjsf .form-group {
    margin-bottom: 0;
  }

  .rjsf fieldset {
    display: flex;
    gap: ${(props) => props.theme.spacing.md};
    flex-wrap: wrap;
    border: none;
    padding: 0;
    margin: 0;
  }

  .rjsf legend {
    display: none;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.sm};
  flex-shrink: 0;
`;
